import {Component, Input, OnInit} from '@angular/core';
import {Institute} from "../../../../api/models/institute.model";

@Component({
    selector: 'app-admission-header',
    imports: [],
    templateUrl: './admission-header.component.html'
})
export class AdmissionHeaderComponent implements OnInit{
    ngOnInit(): void {
        console.log(this.institute);
    }
    @Input() institute: Institute | null = null;
    @Input() defaultLogo: string = 'logo-login.svg';


}
